var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['image-block', {
        block: _vm.layout.inline
    }]},[_c('img',{staticClass:"image-holder",attrs:{"src":_vm.layout.imageblock,"alt":'Fullscreen picture ' + _vm.layout.imageblock.split('/').pop().split('.')[0]}})])}
var staticRenderFns = []

export { render, staticRenderFns }